<template>
  <div v-if="open" class="dialog">
    <v-dialog
      v-model="open"
      :width="size"
      :height="size"
      :hide-overlay="hideOverlay"
      :persistent="persistent"
    >
      <div class="dialog-content">
        <v-btn
          flat
          icon
          class="dialog-close-button"
          @click.prevent="$emit('close')"
        >
          <v-icon
            small
            color="gray"
          >
            close
          </v-icon>
        </v-btn>

        <div style="overflow: hidden;overflow-y: auto;">
          <slot />
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'Dialog',
  props: {
    body: { type: String, default: '' },
    hideOverlay: { type: Boolean, default: false },
    open: { type: Boolean, required: false, default: false },
    origin: { type: String, default: 'center center' },
    persistent: { type: Boolean, default: true },
    size: { type: Number, default: 400 },
    title: { type: String, default: '' }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import 'assets/scss/variables';

.dialog {
  &-content {
    position: relative;
    padding: 24px;
    border-radius: 8px;
    background-color: $neutral100;
    border: 1px solid $neutral300;
    transition: width 0.2s linear;

    .dialog-close-button {
      position: absolute;
      top: 16px;
      right: 16px;
      margin: 0;
      z-index: 10;
    }
  }
}
</style>
